import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { useSelector } from 'react-redux';
import { activeNetworkSelector } from '../../redux/selectors';
import { METRICS, INTERVALS } from './filtersOptions';

export const FiltersContext = createContext();

const useGroupMetrics = (activeNetwork) =>
  useMemo(
    () =>
      METRICS.reduce((acc, metric) => {
        if (!activeNetwork?.features?.includes('job_board') && metric.group !== 'intros') {
          return acc;
        }

        if (!activeNetwork?.connect?.hasAccess && metric.group === 'intros') {
          return acc;
        }

        acc[metric.group] = acc[metric.group] || [];
        acc[metric.group].push(metric);
        return acc;
      }, {}),
    [activeNetwork],
  );

function AnalyticsContext({ children }) {
  const activeNetwork = useSelector(activeNetworkSelector);
  const groupedMetrics = useGroupMetrics(activeNetwork);

  const [filters, setFilters] = useState({
    metric: !activeNetwork.features?.includes('job_board') ? groupedMetrics.intros[0] : METRICS[0],
    interval: INTERVALS[0],
    startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });

  const updateFilters = (newState, reset = false) => {
    if (reset) {
      return setFilters({});
    }

    return setFilters((prevState) => ({ ...prevState, ...newState }));
  };

  return (
    <FiltersContext.Provider value={{ filters, updateFilters, groupedMetrics }}>{children}</FiltersContext.Provider>
  );
}

AnalyticsContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AnalyticsContext;
